import {useEffect, useState} from "react";
import {PayoutSystemStatusModel, PayoutSystemStatusSeverity} from "../redux/types";
import {restConfig} from "../authConfig";
import useFetchClient from "./useFetchClient";
import {Colors} from "../constants/colors";

export const getPayoutSystemSeverityColor = (severity?: PayoutSystemStatusSeverity) => {
  switch (severity) {
    case PayoutSystemStatusSeverity.ok:
      return "#2ecc71"; // Green
    case PayoutSystemStatusSeverity.minor:
      return "#f39c12"; // Yellow/Orange
    case PayoutSystemStatusSeverity.major:
      return "#e74c3c"; // Red
    case PayoutSystemStatusSeverity.critical:
      return "#c0392b"; // Dark Red
    default:
      return Colors.white;
  }
};

const usePayoutSystemStatus = () => {

  const fetchClient = useFetchClient()
  const [payoutSystemStatus, setPayoutSystemStatus] = useState<PayoutSystemStatusModel>()

  const fetchPayoutSystemStatus = async () => {
    return fetchClient.get(restConfig.routes.swish + '/system')
      .then(response => {
        return response.data as PayoutSystemStatusModel
      })
      .catch(error => {
        console.error('Error fetching Payout system status:', error);
        return undefined;
      })
  }

  useEffect(() => {
    const updatePayoutSystemStatus = () => {
      fetchPayoutSystemStatus()
        .then(response => {
          setPayoutSystemStatus(response)
        })
        .catch(error => {
          console.error(error)
        });
    }

    updatePayoutSystemStatus()

    const intervalId = setInterval(() => {
      updatePayoutSystemStatus()
    }, 30000);

    return () => clearInterval(intervalId);
  }, []);

  return payoutSystemStatus
}

export default usePayoutSystemStatus
